import styled from 'styled-components'

export const Container = styled.div`
  padding: 0 0 24px 24px;
  margin-top: 24px;
`

export const ContainerScroll = styled.div`
  width: 97%;
  max-height: 130px;
  overflow: auto;
  overflow-x: hidden;
  margin-right: 11px;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    margin-top: 8px;
    border-radius: 5px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 5px;
    box-shadow: inset 0 0 5px #adadad;
  }
`

export const Subtitle = styled.div`
  font-size: 12px;
  line-height: 20px;
  font-weight: 500;
  color: ${(props) => props.theme.colors.grey[300]};
  text-align: left;
  margin-top: 0;
`
